module.exports = __webpack_public_path__ + "fonts/anitta-icons.b5332264.woff";